import { MediaBox, Picture, Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

const ProtectionPlanBanner = styled(MediaBox).attrs((props) => ({
  bg: props.theme.extendWarranty.protectionPlanBanner.bg,
}))``

const ProtectionCoverageJewlr = () => {
  return (
    <ProtectionPlanBanner
      mb={{ tablet: 6 }}
      pb={{ _: 5, tablet: 7 }}
      pt={5}
      textAlign="center"
    >
      <Picture
        alt="Jewlr + Extend"
        fallback={require("images/info/warranty/jewlr-extend.png")}
        srcSet={[
          {
            height: "246",
            media: "(max-width: 767px)",
            sizes: "232px",
            srcSet: `${require("images/info/warranty/m-jewlr-extend.png")} 356w, ${require("images/info/warranty/m-jewlr-extend-2x.png")} 712w`,
            width: "356",
          },
          {
            height: "142",
            media: "(min-width: 768px)",
            sizes: "468px",
            srcSet: `${require("images/info/warranty/jewlr-extend.png")} 772w, ${require("images/info/warranty/jewlr-extend-2x.png")} 1548w`,
            width: "772",
          },
        ]}
        width={{ _: "232px", tablet: "468px" }}
      />
      <Typography
        color="black"
        fontSize={{ _: "30px", tablet: "32px" }}
        px={{ _: 6, tablet: 0 }}
      >
        Add Protection Coverage
      </Typography>
    </ProtectionPlanBanner>
  )
}

export default ProtectionCoverageJewlr
